import { h, Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import Button from '../Button.js';


class TwoFactorConfirm extends Component {
  
	constructor(props) {
  	super(props);
  	this.state = {
      recoveryCode: undefined,
      buttonEnd2FA: 'loading',
      validRender: false
  	};
  }
  
  routeToSecurity = () => {
    route('/security', true);
  }

  fetchRecoveryCode = (webToken) => {
    fetch('https://api.hirezstudios.com/acct/createSingleUseCode', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: `{"webToken": "${webToken}"}`
		}).then((response) => response.json()).then((response) => {
      if (response.code) {
        this.setState({
          buttonEnd2FA: 'initial',
          recoveryCode: response.code
        });
      }
      else {
        // something went wrong
      }
    })
  }

  componentDidMount() {
    if (this.props.userData.webToken) {
      this.fetchRecoveryCode(this.props.userData.webToken);
    }
    if (this.props.previousRoute === '/two-factor') {
      this.setState({
        validRender: true
      });
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.state.recoveryCode === undefined) {
      this.fetchRecoveryCode(nextProps.userData.webToken);
    }
    if (nextProps.previousRoute !== this.props.previousRoute && nextProps.previousRoute === '/two-factor') {
      this.setState({
        validRender: true
      });
    }
  }


	render() {
    const { t } = this.props;
    return (
      <div>
      {this.state.validRender === true &&
        <div className="c-TwoFactorConfirm">
          <h1>{t('Security - Confirm & Recovery Code')}</h1>
          <p>{t('You\'ve successfully updated your Two Factor Authentication settings!')}</p>
          <p>{t('We\'ve provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.')}</p>
          <p><strong>{t('Please store this recovery code in a safe location.')}</strong></p>
          <div className="recovery-code">{this.state.recoveryCode}</div>
          <div className="buttons-wrapper save-settings">
            <Button
                color="blue"
                copy={t('Continue')}
                state={this.state.buttonEnd2FA}
                onClick={this.routeToSecurity}
              />
            </div>
        </div>
      }
      </div>
    );
	}
}

export default translate(['common'], { withRef: true })(TwoFactorConfirm);


// WEBPACK FOOTER //
// ./components/views/TwoFactorConfirm.js